export default __webpack_public_path__ + "static/media/item-2.0881b872.png";